import { motion } from "framer-motion";
import styled from "styled-components";

export const primaryBtn = styled(motion.button)`
  /* font-family: "Tajawal", sans-serif; */
  font-size: 1.2rem;
  font-weight: bold;
  padding: 0.5rem 1.7rem;
  color: white;
  border: solid 3px transparent;
  background-image: linear-gradient(
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0)
    ),
    linear-gradient(101deg, #962dce, #6de8fb);
  background-origin: border-box;
  background-clip: content-box, border-box;
  box-shadow: 2px 1000px 1px black inset;
  font-family: "Work Sans", sans-serif;
  a {
    color: white;
    text-decoration: none;
  }
  :hover {
    box-shadow: none;
    color: white;
  }

  :active {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.35),
      inset 0px 4px 4px rgba(0, 0, 0, 0.35);
  }

  :focus {
    outline: none;
  }
`;

export const templatePageDiv = styled(motion.div)`
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
